import React from "react";
import { Chip } from "@mui/material";
import { SECTION } from "@/constants/examConstants";

/**
 * Static metadata for the 7 TOEIC parts. Used by the part picker (where we only
 * have part *numbers* from `availableParts`) and anywhere we need a label/section
 * without a full exam payload. The authoritative `section` always comes from the
 * server when a real part object is available.
 */
export const PART_META = {
  1: { label: "Part 1 — Photographs", section: SECTION.LISTENING },
  2: { label: "Part 2 — Question-Response", section: SECTION.LISTENING },
  3: { label: "Part 3 — Conversations", section: SECTION.LISTENING },
  4: { label: "Part 4 — Talks", section: SECTION.LISTENING },
  5: { label: "Part 5 — Incomplete Sentences", section: SECTION.READING },
  6: { label: "Part 6 — Text Completion", section: SECTION.READING },
  7: { label: "Part 7 — Reading Comprehension", section: SECTION.READING },
};

export const partLabel = (partNumber) =>
  PART_META[partNumber]?.label || `Part ${partNumber}`;

export const partSection = (partNumber) =>
  PART_META[partNumber]?.section || SECTION.READING;

/**
 * Header chips shown above the public mock test review dialog.
 * - Full mode: Total / Listening / Reading.
 * - Part mode: one outlined chip per selected part.
 *
 * Both the post-submit review and the persisted-history review use this so
 * their headers stay in sync.
 */
export const buildPublicMockHeaderChips = ({
  isPart,
  score = 0,
  listeningScore = 0,
  readingScore = 0,
  parts = [],
}) => {
  if (isPart) {
    return parts.map((p) => (
      <Chip key={p} label={partLabel(p)} variant="outlined" />
    ));
  }
  return [
    <Chip key="total" label={`Total: ${score}/990`} color="secondary" />,
    <Chip key="listening" label={`Listening: ${listeningScore}/495`} color="info" />,
    <Chip key="reading" label={`Reading: ${readingScore}/495`} color="info" />,
  ];
};
